import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";

/**
 * A small EN | ES pill toggle. Designed for the listing header — premium,
 * thumb-friendly on mobile, doesn't compete with the main CTAs.
 */
export default function LanguageToggle({ className = "", size = "default" }) {
  const { lang, setLang } = useLanguage();
  const sm = size === "sm";

  const Pill = ({ value, label }) => {
    const active = lang === value;
    return (
      <button
        type="button"
        onClick={() => setLang(value)}
        aria-pressed={active}
        data-testid={`lang-toggle-${value}`}
        className={`
          relative ${sm ? "px-3 py-1 text-xs" : "px-3.5 py-1.5 text-sm"}
          font-semibold rounded-full transition-all duration-200
          ${active
            ? "bg-gradient-to-r from-[#F4B41A] to-[#E0A015] text-[#0A0F1C] shadow-md"
            : "text-[#94A3B8] hover:text-white"}
        `}
      >
        {label}
      </button>
    );
  };

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border border-white/10 bg-white/5 backdrop-blur p-1 ${className}`}
      data-testid="language-toggle"
      role="group"
      aria-label="Language selection"
    >
      <Globe className={`${sm ? "w-3.5 h-3.5" : "w-4 h-4"} text-[#94A3B8] ml-1.5`} aria-hidden />
      <Pill value="en" label="EN" />
      <Pill value="es" label="ES" />
    </div>
  );
}
